import cx from 'classnames'

import { SanityFooterBlock } from '@data/sanity/queries/types/site'

import Menu from '@blocks/navigation/menu'
import ComplexPortableText from '@components/portable-text/complex'

interface FooterBlockProps {
  block: SanityFooterBlock
  className?: string
}

const FooterBlock = ({ block, className }: FooterBlockProps) => {
  return (
    <div className={cx('flex flex-col text-left', className)}>
      <h3 className="text-lg mb-4">{block.title}</h3>

      {'description' in block && !!block.description && (
        <ComplexPortableText content={block.description} className="rc mb-5" />
      )}

      {'menu' in block && !!block.menu && (
        <Menu items={block.menu.items} isFooterMenu />
      )}

      {'social' in block && !!block.social && (
        <ul className="flex flex-col lg:mb-8 px-0">
          {block.social.map((link) => (
            <li key={link._key}>
              <a
                key={link._key}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-60 transition-opacity duration-200 inline-block text-base text-left"
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default FooterBlock
